import { Database, Plus } from '@ondit/ui/icons'
import { noop } from '@ondit/utils/helpers'
import {
  type BreadcrumbItem,
  type ChromeActionSpec,
  ResourceChromeFallback,
} from '@/screens/workspace/components'
import { FOLDERED_RESOURCE_HEADERS } from '@/screens/workspace/components/folders/foldered-resources'
import { DOCUMENT_COLUMNS } from '@/screens/workspace/knowledge/base/document-columns'
import { useT } from '~/core/i18n'

const KNOWLEDGE_HEADER = FOLDERED_RESOURCE_HEADERS.knowledge_base

const ACTIONS = [
  { text: 'New documents', icon: Plus, variant: 'primary' },
] satisfies ChromeActionSpec[]

const BREADCRUMBS: BreadcrumbItem[] = [
  { label: KNOWLEDGE_HEADER.rootLabel, icon: Database, onClick: noop },
  { label: '…', terminal: true },
]

export default function KnowledgeBaseLoading() {
  const t = useT()
  return (
    <ResourceChromeFallback
      icon={Database}
      breadcrumbs={BREADCRUMBS}
      columns={DOCUMENT_COLUMNS.map((column) => ({ ...column, header: t(column.header) }))}
      actions={ACTIONS.map((action) => ({ ...action, text: t(action.text) }))}
      searchPlaceholder={t('Search documents...')}
      hasSort
      hasFilter
    />
  )
}
